import styled from '@emotion/styled';

export const SecondaryText = styled.h5({
    color: '#9a9a98',
    fontFamily: "'FT Regola Neue'",
    fontSize: '1rem',
    fontStyle: 'normal',
    fontWeight: 500,
    letterSpacing: '-0.48px',
    lineHeight: '1.125rem',
    margin: 0,
});
